
import { Component, Vue } from "vue-property-decorator";
import {
  Mind,
  PsycGaugeConfig,
  Vir,
  ExamV2Custom
} from "@/lib/model/exambuilder/exam-v2";
import ExamV3Custom, {
  ExamV3,
  VerifyExamCheck
} from "@/lib/model/exambuilder/exam-v3/exam-v3";
import {
  BasicInformation,
  PsychologicalMotivation
} from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
// 导出相关接口没有变化使用的还是旧版的
import Candidate, {
  CandidateMCreateParams,
  CandidateMCreateParseParams
} from "@/lib/model/exam/candidate";
import { CandidateListExportParams } from "@/lib/model/exam/candidate";
import CandidateCreateForm, {
  StructParam
} from "@/lib/form/candidate/CandidateCreateForm";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import { CandidateCount, CandidateCountResponse } from "@/lib/dash/dash-v3";
import ModelDrawer from "@/views/ai-builder-v3/components/drawer/index.vue";
import Auth from "@/lib/common/auth";
import Loading from "@/components/loading.vue";
import ManageAuth from "../components/manage-auth.vue";
import DelExam from "../components/del-exam.vue";
import SelectTemplate from "../components/select-template.vue";
import AsyncDownloadModal from "../components/async-download-modal.vue";
import ExamInfo from "../components/exam-info.vue";
import ExamLink from "../components/exam-link.vue";
import ExamList from "@/lib/model/exam/exam";
import RingGraph from "@/views/exam-v3/components/ring-graph.vue";
import TableChars from "@/views/exam-v3/components/table-chars.vue";
import CandidateTable from "@/views/exam-v3/components/candidate-table.vue";
import AddMoreCandidateModal from "@/views/exam-v3/components/add-candidates.vue";
import AddOneCandidateModal from "@/views/exam-v3/components/add-candidate.vue";
import CandidateV3Custom, {
  CandidateV3Item
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3";
import { EnumSubmitStatus } from "@/lib/model/exambuilder/candidate-v3/candidate-v3-enum";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import vuexStore, { EnumEditStatus } from "@/store/vuex-store";
import EllipShow from "@/components/ellipShow.vue";
import { Check } from "@/lib/enum/check";
import Template from "@/views/ai-builder/components/template.vue";

const psycGaugeIdMap = {
  [Check.BIG_FIVE_240]: 1,
  [Check.DISC]: 3,
  [Check.BIG_FIVE_60]: 4,
  [Check.DVF]: 5
};
@Component({
  components: {
    Template,
    CandidateTable,
    DelExam,
    ManageAuth,
    SelectTemplate,
    AsyncDownloadModal,
    ModelDrawer,
    ExamInfo,
    ExamLink,
    RingGraph,
    TableChars,
    Loading,
    AddMoreCandidateModal,
    AddOneCandidateModal,
    EllipShow
  }
})
export default class ExamCandidateList extends Vue {
  pageShow = false;
  virList: Vir[] = []; //虚拟人列表
  examV3: ExamV3Custom = new ExamV3Custom();
  candidateCountInfo: CandidateCountResponse = new CandidateCountResponse();
  mindList: PsycGaugeConfig[] = [];
  visible = false;
  isShowDownloadModal = false;
  // 编辑基本信息/复制面试
  examInfoMode = "edit";
  showExamInfo = false;
  editExamInfoParam = new BasicInformation();
  // 添加候选人
  isShowAddOne = false;
  isShowAddMore = false;

  candidateCreateForm = new CandidateCreateForm();
  examGetForm: ExamGetForm = new ExamGetForm();
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();
  // 邀请候选人弹窗
  showExamLink = false;
  scanLink = "";
  scanUrl = "";
  echartsList = [
    {
      proportion: 0,
      tip: "到面率=参面人数/邀请人数",
      name: "到面率"
    },
    {
      proportion: 0,
      tip: "完面率=完面人数/参面人数",
      name: "完面率"
    }
  ];
  recommendList: number[] = [];
  showManageAuth = false;

  showSelectTemplate = false;
  // 编辑基本信息
  showDelExam = false;
  delParam = {
    examId: 0,
    name: ""
  };
  isOldExam = false;
  closeAddOneCandidate() {
    this.isShowAddOne = false;
  }

  changeEditStatus(status: EnumEditStatus) {
    vuexStore.setEditStatus(status);
  }

  closeAddMoreCandidate() {
    this.isShowAddMore = false;
  }
  // 添加候选人成功
  async successAddMore() {
    this.getCandidateList();
    // vuexStore.removePages("exam-list-v3");
  }
  setTemplateOK() {
    this.$message.success("保存成功");
    this.showSelectTemplate = false;
  }
  get totalTime() {
    const m = Math.floor(this.examV3.processInformation.allTestingTime / 60);
    const s = this.examV3.processInformation.allTestingTime % 60;
    return m + Number(Boolean(s));
  }
  // 面试有效期
  get interviewValidityPeriod() {
    return this.examV3.settingInformation.interviewValidityPeriod;
  }
  // 面试预览
  handleClose() {
    this.visible = false;
  }
  async delSuccess() {
    const res = await ExamV3.delete(this.examV3.examId, this.examV3.companyId);

    if (res.code !== 0) return;

    this.showDelExam = false;
    this.$message.success("删除成功");
    // vuexStore.removePages("exam-list-v3");
    this.changeEditStatus(EnumEditStatus.EnumInsert);
    this.back();
  }
  async showDialog(scenes: string) {
    if (scenes === "link") {
      const params = {
        examId: this.examV3.examId,
        companyId: parseInt(Auth.companyId)
      };

      const wsaRes = await ExamList.wsaCode(params);

      if (wsaRes.code !== 0) return;

      this.showExamLink = true;
      this.scanLink = wsaRes.data.base64string
        ? `data:image/png;base64,${wsaRes.data.base64string}`
        : "";

      const urlRes = await ExamList.examUrl(params);

      if (urlRes.code !== 0) return;

      this.scanUrl = urlRes.data.url;

      return;
    }

    if (scenes === "examInfo") {
      this.examInfoMode = "edit";
      this.editExamInfoParam = new BasicInformation().assign({
        name: this.examV3.basicInformation.name,
        remark: this.examV3.basicInformation.remark,
        positionId: this.examV3.basicInformation.positionId
      });
      this.showExamInfo = true;
      return;
    }

    if (scenes === "copyExam") {
      this.examInfoMode = "copy";
      this.showExamInfo = true;
      this.editExamInfoParam = new BasicInformation().assign({
        name: this.examV3.basicInformation.name,
        remark: this.examV3.basicInformation.remark,
        positionId: this.examV3.positionId
      });
      return;
    }

    if (scenes === "removeExam") {
      this.showDelExam = true;
      this.delParam = {
        name: this.examV3.basicInformation.name,
        examId: this.examV3.examId
      };
      return;
    }

    if (scenes === "manageAuth") {
      this.showManageAuth = true;
      return;
    }

    if (scenes === "messageTemplate") {
      this.showSelectTemplate = true;
      return;
    }

    if (scenes === "exportCandidate") {
      this.exportCandidate();
      return;
    }
    if (scenes === "examQuestion") {
      this.$router.push({
        name: "aihr-builder",
        query: {
          paperId: this.examV3.examId as any,
          cid: Auth.companyId,
          step: "1"
        }
      });
      return;
    }
    if (scenes === "examConfig") {
      this.$router.push({
        name: "aihr-builder",
        query: {
          paperId: this.examV3.examId as any,
          cid: Auth.companyId,
          step: "4"
        }
      });

      return;
    }
    if (scenes === "addCandidate") {
      return this.showAddCandidate("one");
    }

    if (scenes === "addCandidates") {
      return this.showAddCandidate("more");
    }
  }
  showAddCandidate(key: string) {
    this.examGetForm.examId = this.examV3.examId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.examId = this.examV3.examId;
    this.candidateMCreateParams.examId = String(this.examV3.examId);
    this.candidateMCreateParams.companyId = Auth.companyId;

    if (key === "one") {
      ExamList.examGet(this.examGetForm)
        .then(res => {
          this.candidateCreateForm.paramList = res.paramList.filter(
            (e: StructParam) => e.isShow == 1
          );
          this.candidateCreateForm.companyId = this.examGetForm.companyId;
          this.candidateCreateForm.examId = this.examGetForm.examId;
        })
        .finally(() => {
          this.isShowAddMore = false;
          this.isShowAddOne = true;
          this.changeEditStatus(EnumEditStatus.EnumInsert);
        });
    } else if (key === "more") {
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }
  confirm() {
    this.changeEditStatus(EnumEditStatus.EnumInsert);
  }
  candidateDel() {
    this.changeEditStatus(EnumEditStatus.EnumInsert);
  }
  exportCandidate() {
    const params = ({
      companyId: Auth.companyId,
      examId: this.examV3.examId,
      asCompany: 0,
      isFsk: 0
    } as unknown) as CandidateListExportParams;
    Candidate.candidateListExport(params).then(res => {
      if (res.code === 0) {
        if (res.data.isAsync === 1) {
          this.isShowDownloadModal = true;
        } else {
          const dataUrl = res.data.ossUrl;
          const a = document.createElement("a");
          a.href = dataUrl;
          a.setAttribute("download", "面试详情");
          a.click();
        }
      }
    });
  }
  // 候选人数量统计
  async candidateCount() {
    try {
      const {
        inviteNumber, // 邀请
        joinNumber, // 参面
        finishNumber,
        finish
      } = (this.candidateCountInfo = await CandidateCount.get({
        companyId: +Auth.companyId,
        userId: +Auth.userId,
        examId: this.examV3.examId || 6020
      }));

      if (inviteNumber !== 0) {
        this.echartsList[0].proportion = (joinNumber * 100) / inviteNumber;
      }
      if (joinNumber !== 0) {
        this.echartsList[1].proportion = (finishNumber * 100) / joinNumber;
      }
      this.recommendList = [
        finish.aiRecommendStatusVeryRecommend,
        finish.aiRecommendStatusRecommend,
        finish.aiRecommendStatusNormal,
        finish.aiRecommendStatusNotRecommend
      ];
      this.$nextTick(() => {
        const ref = this.$refs.TableChars as any;
        try {
          ref.option.series[0].left = "-160px";
          ref.option.series[0].radius = "100%";
          ref.option.series[0].top = "16px";
          ref.option.legend.top = "28px";
          delete ref.option.series[0].width;
        } catch (error) {
          //
        }
        ref.updateOption();
      });
    } catch (error) {
      console.log("统计", error);
    }
  }
  async created() {
    const { isOk } = await VerifyExamCheck.getVerifyExam({
      companyId: +Auth.companyId,
      examId: +this.$route.query.examId || 0
    });
    if (isOk) {
      await this.getExamV3();
    } else {
      this.isOldExam = true;
      await this.getExam();
    }
    await this.getCandidateList();
  }

  // 获取旧版面试信息
  async getExam() {
    const exam = await ExamList.examGetAi({
      companyId: +Auth.companyId,
      examId: +this.$route.query.examId || 0
    });
    this.examV3 = await ExamV3.echoAssgin(new ExamV2Custom().assign(exam));
    this.searchForm.examId = this.examV3.examId;
    this.candidateCount();
    this.pageShow = true;
    this.getMindList();
    this.virList = await Vir.getList();
  }

  // 获取新版面试信息
  async getExamV3() {
    try {
      const examV3 = await ExamV3.get({
        companyId: Auth.companyId,
        examId: this.$route.query.examId || 0
      });
      if (this.$route.query.examId) {
        examV3.examId = +this.$route.query.examId;
      }
      this.examV3 = examV3;
      this.searchForm.examId = examV3.examId;
      this.candidateCount();
      this.pageShow = true;
      this.getMindList();
      this.virList = await Vir.getList();
    } catch (error) {
      console.log("error:", error);
      this.pageShow = true;
    }
  }
  // 心理相关题目处理
  initSelectedPsyc(psychologicalMotivation: PsychologicalMotivation) {
    const { psyc1, psyc4 } = psychologicalMotivation;

    if (psyc1.use === 1) {
      const psycId = psycGaugeIdMap[Check.BIG_FIVE_240];
      const mindObj =
        this.mindList.find(item => item.psycGaugeId === psycId) ||
        new PsycGaugeConfig();

      psyc1.psycGaugeSubDimensionList = mindObj.dimensionList.reduce(
        (pre: any[], item) => {
          const list = item.subDimensionList
            .filter(sItem =>
              psyc1.psycGaugeSubDimensionIdList.includes(
                sItem.psycGaugeDimensionId
              )
            )
            .map(sItem => ({
              id: sItem.psycGaugeDimensionId,
              questionCount: sItem.questionCount
            }));

          return [...pre, ...list];
        },
        []
      );
    }

    if (psyc4.use === 1) {
      const psycId = psycGaugeIdMap[Check.BIG_FIVE_60];
      const mindObj =
        this.mindList.find(item => item.psycGaugeId === psycId) ||
        new PsycGaugeConfig();

      psyc4.psycGaugeSubDimensionList = mindObj.dimensionList
        .filter(item =>
          psyc4.psycGaugeSubDimensionIdList.includes(item.psycGaugeDimensionId)
        )
        .map(item => ({
          id: item.psycGaugeDimensionId,
          questionCount: item.questionCount
        }));
    }
  }
  async getMindList() {
    const res = await Mind.get();

    if (res.data.code !== 0) return;

    this.mindList = res.data.data.list.map((item: any) => {
      return new PsycGaugeConfig().assign(item);
    });
    this.initSelectedPsyc(
      this.examV3.processInformation.psychologicalMotivation
    );
  }
  // 所有需确认请求接口的等待
  submitting = false;
  async examInfoEditOk(data: BasicInformation) {
    if (this.submitting) return;
    this.submitting = true;
    if (this.examInfoMode === "edit") {
      if (this.isOldExam) {
        // 通用版本走旧接口
        const res = await ExamV2Custom.updateName({
          examId: this.examV3?.examId || 0,
          name: data.name,
          remark: data.remark,
          positionId: data.positionId
        });

        if (res.data.code !== 0) return;

        await this.getExam();
      } else {
        // 重构版本走新接口
        const res = await ExamV3.update(
          new ExamV3Custom().assign({
            companyId: this.examV3?.companyId || 0,
            examId: this.examV3?.examId || 0,
            updateType: "basicInformation",
            basicInformation: data
          })
        );

        if (res.code !== 0) return;

        this.getExamV3();
      }

      this.changeEditStatus(EnumEditStatus.EnumInsert);
      this.$message.success("编辑成功");
      this.submitting = false;
    } else {
      const res = await ExamV3.copy({
        companyId: this.examV3?.companyId || 0,
        examId: this.examV3?.examId || 0,
        name: data.name,
        remark: data.remark,
        positionId: data.positionId
      });

      if (res.code !== 0) return;

      this.$message.success("复制成功");
      // vuexStore.removePages("exam-list-v3");
      this.changeEditStatus(EnumEditStatus.EnumInsert);
      this.back();
    }

    this.showExamInfo = false;
  }

  // 筛选相关
  searchForm = new CandidateListForm().assign({
    companyId: Number(Auth.companyId),
    examType: "aibuilder",
    sortKey: "",
    sortDict: ""
  });

  // 登记状态
  get EnumSubmitStatus() {
    return EnumSubmitStatus;
  }
  submitStatus: string | EnumSubmitStatus = "";

  handleChangeSubmitStatus(val: "" | EnumSubmitStatus) {
    this.searchForm.page = 1;

    if (val === "") {
      this.searchForm.submitStatusList = [];
      return this.getCandidateList();
    }

    if (val === EnumSubmitStatus.EnumSubmitStatusFinish) {
      this.searchForm.submitStatusList = [
        EnumSubmitStatus.EnumSubmitStatusFinish,
        EnumSubmitStatus.EnumSubmitStatusNoScore
      ];
      return this.getCandidateList();
    }

    this.searchForm.submitStatusList = [val];
    this.getCandidateList();
  }

  // 表头相关（全部自定义登记信息）
  paramList: string[] = [];

  // 列表数据
  loadingList = true;
  data: CandidateV3Item[] = [];
  total = 0;

  // 获取面试候选人列表
  async getCandidateList() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.loadingList = true;
    const res = await CandidateV3Custom.get(this.searchForm);
    this.data = res.list;
    this.total = res.count;
    this.paramList = res.list[0]?.paramList.map(item => item.name) || [];
    this.loadingList = false;
  }

  // 快速搜索
  handleQuickSearch({ type, row }: { type: string; row: CandidateV3Item }) {
    this.searchForm.page = 1;

    if (type === "repeatExam") {
      this.searchForm.submitStatusList = [];
      this.searchForm.showNameOrPhone = row.phone;
      this.getCandidateList();
    }
  }
  back() {
    this.$router.push({ path: "/exam/list", params: { fromDetail: "1" } });
  }
}
